<!--
    描述： 新增系统内项目
    时间： xx
    created by ws
-->
<template>
	<div class="inner-main baseList-layout">
		<div class="baseList-header">
			<search-area ref="searchContent"
						 searchName="sname"
						 placeholderName="工程名称"
						 :showMore="false"
						 @on-search="onSearch"
						 @on-refresh="onRefresh"
						 @on-input="onInput">
			</search-area>
		</div>
		<div class="baseList-content">
			<div class="table-layout">
				<div class="table-content"
					 ref="tableContent">
					<el-table class="w100 h100"
							  :height="tableH"
							  max-height="500px"
							  :data="showData"
							  highlight-current-row
							  stripe
							  @selection-change="handleSelect">
						<el-table-column type="selection"
										 label="序号"
										 align="center"
										 width="55">
						</el-table-column>
						<el-table-column prop="projectName"
										 label="工程名称"
										 min-width="180">
						</el-table-column>
						<el-table-column prop="projectPatten"
										 label="项目类型"
										 width="110">
						</el-table-column>
						<el-table-column prop="areaName"
										 label="地区"
										 align="center"
										 width="130">
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import { mapState, mapActions } from 'vuex'
// import { saveInnerSysProjects } from 'api/module/home'
const searchArea = () => import('./searchArea')
export default {
	name: 'addold',
	components: {
		searchArea
	},
	data() {
		return {
			tableH: 450, // 表格高度
			currentPage: 1, // 当前页码
			pageList: [10, 20, 50, 100], // 显示条数数组
			pageSize: 10, // 当前显示条数
			total: 0, // 当前总条数
			tableData: [],
			showData: [],	// 实际查询展示的数据
			selectedArr: [], // 当前选择的数据
			searchForm: {
				sname: '',	// 搜索查询
			}
		}
	},
	created() {
		// // 初始获得表格数据
		// this.tableData = JSON.parse(JSON.stringify(this.sysProjectList))
		// this.showData = JSON.parse(JSON.stringify(this.sysProjectList))
		// // this.$nextTick(() => {
		// // 	this.tableH = this.$refs.tableContent.offsetHeight
		// // })
	},
	methods: {
		// ...mapActions('projectHome', ['loadSystemList']),
		// // 切换显示条数
		handleSizeChange(val) {
			console.log('当前页面显示的条数是' + val)
		},
		// 切换当前页码
		handleCurrentChange(cur) {
			console.log('当前的页码是' + cur)
		},
		// 复选框发生变化时的事件
		handleSelect(selection) {
			this.selectedArr = selection
		},
		// 确认提交
		doConfirm() {
			// if (this.selectedArr.length > 0) {
			// 	// doSomething
			// 	let arr = JSON.parse(JSON.stringify(this.selectedArr))
			// 	saveInnerSysProjects(arr).then(res => {
			// 		console.log(res)
			// 		if (res.operationCode === 1) {
			// 			this.loadSystemList()
			// 			this.$emit('onSuccess')
			// 		}
			// 	})
			// } else {
			// 	setTimeout(() => {
			// 		this.$emit('onCancel')
			// 	}, 2000)
			// 	this.$message.warning('请选择要添加的项目')
			// }
			console.log(8888)
		},

		// 确认查询
		onSearch() {
			// console.log(this.searchForm)
			this.showData = this.tableData.filter(x => x.projectName.includes(this.searchForm.sname))
		},

		// 确认刷新
		onRefresh() {
			this.searchForm.sname = ''
			this.showData = this.tableData
		},

		// 输入事件
		onInput(val, attr) {
			this.searchForm[attr] = val
		},
	},
	computed: {
		// ...mapState('common', {
		// 	clientSize: state => state.clientSize
		// }),
		// ...mapState('projectHome', {
		// 	sysProjectList: state => state.sysProjectList
		// })
	},
	watch: {
		// clientSize(obj) {
		// 	this.tableH = this.$refs.tableContent.offsetHeight
		// }
	}
}
</script>

<style lang="less" scoped>

</style>